module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 13
// module chunks = 0